import { LockClosedIcon, BoltIcon, CheckCircleIcon } from "../../common/Icons";

const BottomFooterBar = () => {
  return (
    // Hidden on mobile (screens smaller than md)
    // Displayed as flex on md screens and up, mt-auto pushes it down in flex container
    <div className={`hidden md:block md:flex bg-[#09517d] py-4 md:mt-auto`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-row flex-wrap justify-center sm:justify-around items-center text-sm text-white gap-x-6 gap-y-3">
          <div className="flex items-center">
            <LockClosedIcon className="w-5 h-5 text-white mr-2" />
            <span>Private and Secure</span>
          </div>
          <div className="flex items-center">
            <BoltIcon className="w-5 h-5 text-white mr-2" />
            <span>Faster Processing</span>
          </div>
          <div className="flex items-center">
            <CheckCircleIcon className="w-5 h-5 text-white mr-2" />
            <span>Convenient</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomFooterBar;
